import Show from 'Components/Show/Show'
import React from 'react'

const RecordPayment = ({ paymentModel, handlePaymentMethod, validationModel }) => {
    return (
        <div>
            <div className="flex items-center">
                <input type="radio" id="PAY_REC" name="patientPaymentType" value="PAY_REC" checked={paymentModel.patientPaymentType === 'PAY_REC'} onChange={handlePaymentMethod} className="w-4 h-4 text-blue-600 focus:ring-blue-500" />
                <label htmlFor="PAY_REC" className="ml-3 text-sm text-slate-700">Record Payment</label>
            </div>
            <Show when={paymentModel.patientPaymentType === 'PAY_REC'}>
                <div className="mt-2 space-y-2 ml-7">
                    <div>
                        <label className="block mb-1 text-xs font-medium text-slate-700">Receive Date</label>
                        <input type="date" name="receivedDate" value={paymentModel.receivedDate} onChange={handlePaymentMethod} className="w-full px-3 py-2 text-sm border rounded-lg border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        {validationModel.receivedDateError}
                    </div>
                    <div className="flex items-center gap-4">
                        <div className="flex items-center">
                            <input type="radio" id="CASH" name="recordPaymentMethod" value="CASH" checked={paymentModel.recordPaymentMethod === 'CASH'} onChange={handlePaymentMethod} className="w-4 h-4 text-blue-600 focus:ring-blue-500" />
                            <label htmlFor="CASH" className="ml-2 text-sm text-slate-700">Cash</label>
                        </div>
                        <div className="flex items-center">
                            <input type="radio" id="CHECK" name="recordPaymentMethod" value="CHECK" checked={paymentModel.recordPaymentMethod === 'CHECK'} onChange={handlePaymentMethod} className="w-4 h-4 text-blue-600 focus:ring-blue-500" />
                            <label htmlFor="CHECK" className="ml-2 text-sm text-slate-700">Check</label>
                        </div>
                    </div>
                    <Show when={paymentModel.recordPaymentMethod === 'CHECK'}>
                        <input type="text" value={paymentModel.checkNumber} onChange={handlePaymentMethod} name="checkNumber" placeholder="Check Number" required className="w-full px-3 py-2 text-sm border rounded-lg border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        {validationModel.checkNumberError}
                    </Show>
                </div>
            </Show>
        </div>
    )
}

export default RecordPayment